import syncFieldTypes from "../../constants/syncFieldTypes";
import { syncSelectors } from "../../modules/sync";
import immutableRecords from "../../types/immutableRecords";
import { listToMap } from "../../utils/immutableExtensions";
import getCustomFieldOptions from "./getCustomFieldOptions";

/**
 *
 * @param {List} orderedColors
 * @param {Map} propertiesById
 * @param {Map} customFieldsIdsMap
 * @param {SyncSettingsRecord} settings
 */
const syncRepresentationOfCustomFields = (orderedColors, propertiesById, customFieldsIdsMap, settings) => {
  const customFieldsList = settings.fields
    .map(field => {
      if (field.customFieldId && syncSelectors.isSyncFieldTypeList(propertiesById, field.id)) {
        // We need to generate a representation of this list
        const id = field.customFieldId;
        const options = getCustomFieldOptions(
          orderedColors,
          propertiesById,
          field.id,
          customFieldsIdsMap.get(field.id)
        );
        return immutableRecords.SyncCustomFieldRecord({
          id,
          options,
          type: syncFieldTypes.LIST
        });
      }
      return null;
    })
    .filter(f => f)
    .toList();

  return listToMap(customFieldsList);
};

export default syncRepresentationOfCustomFields;
